module.exports = __webpack_public_path__ + "static/brodrenedahl-90e162af7190fe837a306c7ce274ffc6.png";